import React from "react";
import { useNavigate } from "react-router-dom";

const Payment = ({ onPlanSelect, setPage }) => {
    const navigate = useNavigate(); 
    
    return (
        <>
            <div className="payment-container">
                <div className="free-container">
                    <div className="free-container-header">
                        Free Plan
                    </div>

                    <div className="free-plan-features">
                        <ul>
                            <li>1 driver's gear figure</li>
                            <li>Lap time comparision for only 2024 and 2025 seasons</li>
                        </ul>
                    </div>

                    <div className="free-container-button">
                        <button onClick={() => {
                            navigate('/create-account'); 
                            onPlanSelect(false); 
                            setPage('sign up'); 
                        }}>Start analysing, now</button>
                    </div>
                </div>
                
                <div className="premium-container">
                    <div className="premium-container-header">
                        Premium Plan
                    </div>

                    <ul className="subscriptions">
                        <li>Monthly Plan<h3>£20</h3> £5.99 GBP/month</li>
                        <li>Annual Plan<h3>£80</h3> £50 GBP</li>
                    </ul>

                    <div className="premium-plan-features">
                        <ul>
                            <li>All driver's gear figures</li>
                            <li>Analyse legendary moments from all seasons</li>
                            <li>AI Insights</li>
                            <li>Early access to new models</li>
                            <li>Unlimited AI prompts</li>
                        </ul>
                    </div>

                    <div className="premium-container-button">
                        <button onClick={() => {
                            navigate('/create-account'); 
                            onPlanSelect(true);
                            setPage('payment'); 
                            }}>Get TelemetryLab Premium</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Payment;